import React from 'react'
import PropTypes from 'prop-types'
import { Tag } from '@/components/atoms'
import { SIZE } from '@/utils/constants/globalStyle'
import { Font } from 'pepsico-ds'
import { Constants, SEGMENT_CHIP_TYPE } from '@/utils/constants/commonConstants'

// Renders a row of removable segment chips with AND/OR separators
export default function SegmentChips({ items, onRemove, className, type }) {
  if (!items || items.length === 0) return null
  const separator = type === SEGMENT_CHIP_TYPE.AND ? Constants.TextAnd : Constants.TextOr

  return (
    <div className={className || 'flex flex-wrap items-center gap-3 pt-1'} data-testid="segment-chips">
      {items.map((s, i) => (
        <React.Fragment key={`chip-${s.id}`}>
          {i > 0 && (
            <span className="text-xs" data-testid={`segment-chip-separator-${i}`}>
              <Font size="xsmall" style={{ color: 'white' }}>
                {separator}
              </Font>
            </span>
          )}
          <span id={`segment-chip-${s.id}`} data-testid={`segment-chip-${s.id}`}>
            <Tag
              text={s.name || s.label}
              isRemovable={true}
              onRemove={() => onRemove(s.id)}
              color="default"
              size={SIZE.MEDIUM}
            />
          </span>
        </React.Fragment>
      ))}
    </div>
  )
}

SegmentChips.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onRemove: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(SEGMENT_CHIP_TYPE)),
}

